/** Aligné sur {@code fr.gavicyconseil.dto.AdresseDto}. */
export class Adresse {
  rueDto?: string;
  complementDto?: string;
  codePostalDto?: string;
  villeDto?: string;
}
